module.exports = __webpack_public_path__ + "static/media/Social-Buddy.4cd33f9f.png";